"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.performValidityEffects = performValidityEffects;
var _utils = require("../../utils");
function performValidityEffects(areAllSpecifiedInputsValid, shouldPerformValidityEffects = true) {
  return function (getState) {
    const {
      config,
      inputStates
    } = getState();
    if (!areAllSpecifiedInputsValid) {
      (0, _utils.invokeValidateCallback)(shouldPerformValidityEffects && config.shouldInvokeValidateCallback);
      (0, _utils.focusFirstInvalidInput)(inputStates, shouldPerformValidityEffects && config.shouldFocusInputOnValidateFail);
    }
  };
}